import NextPrevious from './NextPrevious';

export default NextPrevious;
